module.exports = __webpack_public_path__ + "assets/4a0092b96dfcc00595324d019f636e1f.png";